import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Equipment } from '../../types/equipment';
import { useCategories } from '@hooks';
import { formatCurrency } from '../../utils/helpers';


interface EquipmentCardProps {
  equipment: Equipment;
}

export const EquipmentCard: React.FC<EquipmentCardProps> = ({ equipment }) => {
  const {
    id,
    name,
    description,
    pricePerDay,
    images,
    isFavorite,
    categoryId,
  } = equipment;

  const { categories } = useCategories();
  const category = categories.find(cat => cat.id === categoryId);

  return (
    <Link to={`/equipment/${id}`} className="block relative cursor-pointer">
      <div className="card-hover rounded-xl overflow-hidden bg-white shadow-md transition-all h-full flex flex-col">
        <img
          src={images[0]?.url}
          alt={name}
          className="w-full h-48 object-cover"
        />
        <button
          className="absolute top-3 right-3 bg-white p-1.5 rounded-full shadow-md hover:scale-110 transition-transform"
          onClick={(e) => {
            e.preventDefault();
            // Handle favorite toggle logic here
          }}
        >
          <Heart
            size={18}
            className={isFavorite ? "fill-red-500 text-red-500" : "text-gray-600"}
          />
        </button>


        {category && (
          <div className="absolute top-3 left-3 bg-blue-600 text-white text-xs px-2 py-1 rounded-full">
            {category.name}
          </div>
        )}

        <div className="p-4 flex flex-col flex-grow">
          <div className="flex items-start justify-between mb-1">
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <h3 className="font-semibold text-gray-800 text-lg line-clamp-1">{name}</h3>
            </div>
          </div>

          <div className="flex items-center text-gray-500 text-sm mb-3">
            <span>{description}</span>
          </div>

          <p className="mt-auto font-bold text-gray-800">
            {formatCurrency(pricePerDay)}<span className="text-gray-500 font-normal text-sm"> / día</span>
          </p>
        </div>
      </div>
    </Link>
  );
};